var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouseClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.6875C8.1665 0.690775 5.45 1.81783 3.44641 3.82141C1.44283 5.825 0.315775 8.5415 0.3125 11.375V22.625C0.3125 25.4595 1.4385 28.1779 3.4428 30.1822C5.44709 32.1865 8.1655 33.3125 11 33.3125C13.8345 33.3125 16.5529 32.1865 18.5572 30.1822C20.5615 28.1779 21.6875 25.4595 21.6875 22.625V11.375C21.6842 8.5415 20.5572 5.825 18.5536 3.82141C16.55 1.81783 13.8335 0.690775 11 0.6875ZM20.5625 22.625C20.5625 25.1611 19.555 27.5934 17.7617 29.3867C15.9684 31.18 13.5361 32.1875 11 32.1875C8.46387 32.1875 6.03161 31.18 4.23829 29.3867C2.44497 27.5934 1.4375 25.1611 1.4375 22.625V11.375C1.4375 8.83887 2.44497 6.40661 4.23829 4.61329C6.03161 2.81997 8.46387 1.8125 11 1.8125C13.5361 1.8125 15.9684 2.81997 17.7617 4.61329C19.555 6.40661 20.5625 8.83887 20.5625 11.375V22.625Z",
    fill: "#5B4D68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 5C10.4133 5 10.2702 5.05926 10.1648 5.16475C10.0593 5.27024 10 5.41332 10 5.5625V14.5625C10 14.7117 10.0593 14.8548 10.1648 14.9602C10.2702 15.0657 10.4133 15.125 10.5625 15.125C10.7117 15.125 10.8548 15.0657 10.9602 14.9602C11.0657 14.8548 11.125 14.7117 11.125 14.5625V5.5625C11.125 5.41332 11.0657 5.27024 10.9602 5.16475C10.8548 5.05926 10.7117 5 10.5625 5Z",
    fill: "#5B4D68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseClick);
export default __webpack_public_path__ + "static/media/mouse-click.9f258f7abafac02db9dd2295aac7f679.svg";
export { ForwardRef as ReactComponent };